import { Button } from '@mui/material';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  &.MuiButton-root {
    font-size: ${({ theme }) => theme.fontSize.body2};
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    font-style: normal;
    display: flex;
    padding: ${({ theme }) => theme.spacing.s2};
    justify-content: center;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.s2};
    letter-spacing: 0.032px;

    /* Semantic Border Radius */
    border-radius: var(--radius-md);

    /* Semantic Font Family */
    font-family: var(--font-family-primary);
  }

  &.MuiButton-contained {
    background-color: ${({ color }) =>
      color === 'error' ? 'var(--btn-danger)' : 'var(--btn-primary-bg)'};
    color: var(--btn-primary-text);
    path {
      fill: var(--btn-primary-text);
    }
  }

  &.MuiButton-contained:hover {
    background-color: ${({ color }) =>
      color === 'error'
        ? 'var(--btn-danger-hover)'
        : 'var(--primary-action-hover)'};
  }

  &.MuiButton-contained:active {
    background-color: ${({ color }) =>
      color === 'error'
        ? 'var(--btn-danger-active)'
        : 'var(--primary-action-active)'};
  }

  &.MuiButton-outlined {
    background-color: var(--bg-surface);
    color: var(--text-primary);
    border: 1px solid var(--border-color);
    path {
      fill: var(--text-primary);
    }
  }

  &.MuiButton-outlined:hover {
    background-color: var(--bg-app);
    border: 1px solid var(--text-primary);
  }

  &.MuiButton-outlined:active {
    background-color: var(--bg-surface);
  }

  &.MuiButton-root.Mui-disabled {
    background-color: var(--border-color);
    color: var(--text-disabled) !important;
    path {
      fill: var(--text-disabled);
    }
  }
`;
